<atlas-tab-nav-bar class="dls-page-tab">
  <div atlas-tab-link *ngFor="let tab of pageTabs" [routerLink]="tab.fullPath">
    <span class="text-uppercase">
      {{tab['tabName']}}
    </span>
  </div>
</atlas-tab-nav-bar>